import { findDenominationByServiceId } from './findDenominationByServiceId'

type DenominationWithCountry = {
  serviceId: string
  features?: { country_web?: string }
}

export const resolveDenominationCountry = <T extends DenominationWithCountry>(
  denominations: Record<string, T[]>,
  countryVouchers: { country: string }[] | undefined,
  activeCountry: string | null,
  serviceIdQuery?: string
): string | null => {
  if (activeCountry && denominations[activeCountry]) {
    return activeCountry
  }

  const denominationFromQuery = findDenominationByServiceId(denominations, serviceIdQuery)
  const countryFromQuery = denominationFromQuery ? denominationFromQuery.features?.country_web ?? 'noRegion' : undefined

  if (countryFromQuery && denominations[countryFromQuery]) {
    return countryFromQuery
  }

  if (denominations.noRegion) {
    return 'noRegion'
  }

  return countryVouchers?.[0]?.country ?? Object.keys(denominations)[0] ?? null
}
